<template>
  <div class="permission" :class="`permission--${permission}`" v-tooltip="permissionName"></div>
</template>

<script>
  import lodash from 'lodash';

  export default {
    name: 'Permission',
    props: {
      permission: {
        type: String,
      },
    },
    computed: {
      permissionName() {
        if (this.permission == 'can_contact_am_rd') {
          return 'Contact AM/RM team';
        }
        return lodash.startCase(this.permission.replace('can_', ' ').replace('_', ' '));
      }
    },
  };
</script>

<style scoped lang="scss">
  .permission {
    height: .75em;
    width: .75em;
    border-radius: .75em;
    margin-right: .25em;
    @include m('library') {
      background:#8eadbe;
    }
    @include m('fuel_utilization') {
      background: #2288CE;
    }
    @include m('purchase_activity') {
      background: #26536C;
    }
    @include m('audiology_kpis') {
      background: #BD5151;
    }
    @include m('fuel_funds') {
      background: #b6b68e;
    }
    @include m('digital_promo') {
      background: #FF7200;
    }
    @include m('pricing_guides') {
      background: #F4CA28;
    }
    @include m('vendor_partners') {
      background: #9279C3;
    }
    @include m('can_access_battery_store') {
      background: #444444;
    }
    @include m('can_pay_invoices') {
      background: #97C24B;
    }
    @include m('meeting_agenda') {
      background: #A2466C;
    }
    @include m('can_contact_am_rd') {
      background: #00A5B5;
    }
  }
  .contact {
    @include e(icon) {
      flex:1;
      flex-grow:0;
      min-width: 1.5em;
    }
    @include e(name) {
      flex:1;
    }
    @include e(info) {
      flex:1;
    }
  }
</style>

